var EntityActivityLog = /** @class */ (function () {
    function EntityActivityLog() {
    }
    return EntityActivityLog;
}());
export { EntityActivityLog };
var ActivityLogRequest = /** @class */ (function () {
    function ActivityLogRequest() {
    }
    return ActivityLogRequest;
}());
export { ActivityLogRequest };
var ActivityLog = /** @class */ (function () {
    function ActivityLog() {
    }
    return ActivityLog;
}());
export { ActivityLog };
var ActivityLogIcon = /** @class */ (function () {
    function ActivityLogIcon() {
    }
    return ActivityLogIcon;
}());
export { ActivityLogIcon };
export var IconSourceKinds = {
    GoogleIcon: "GoogleIcon",
    Url: "Url"
};
